import React, { useState, useEffect, useContext } from "react";
// import { fetchContent, fetchContent1 } from "../services/api";
import ValidateQR from "./ValidateQR";
import GetNewCode from "../assets/GetNewCode.png";
import { Translate } from "./LanguageChanger";
import CustomButton from "./CustomButton";
import LoaderScreen from "./LoaderScreen";
import { AppContext } from "../AppContext";
import { generateQrToken, validateQrToken } from "../services/services";
import { sendTestMatomoEvent } from "../Analytics/MatomoManager/matomoTest";

let resolution = window.RESOLUTION;
window.clearTime = null;
let qrEventTriggered = false;


const QRCodeGenerator = ({
  navigate,
  loginData,
  handleRight,
  isExpired,
  setIsExpired,
}) => {
  const [state, setState] = useState({ loading: true, QRCodedata: null });
  const [intervalId, setIntervalId] = useState(null);
  const [timeLeft, setTimeLeft] = useState(600); // 10 minutes in seconds
  // const [isExpired, setIsExpired] = useState(false);
  const [isFocus, setIsFocus] = useState(false);
  const { isLogedIn, setIsLogedIn } = useContext(AppContext);

  const navigateToScreen = (screen = {}) => {
    navigate(screen);
  };

  // console.log("loginData...", loginData);

  // const loadData = async () => {
  //   let headers = {
  //     Version: localStorage.getItem("firmwareVersion") || "04.41.05",
  //     devicetype: "11",
  //     Deviceid: localStorage.getItem("sdkVersion") || "7.4.0",
  //     Devicetoken:
  //       localStorage.getItem("idValue") ||
  //       "c63596ba-5a17-f45b-646f-bfc1619aa4f9",
  //     Devicemodel: localStorage.getItem("modelName") || "32LQ643BPTA",
  //     "Content-Type": "application/json",
  //   };

  //   try {
  //     const fetchQRData = await fetchContent(
  //       "/V1/generateQrToken",
  //       "GET",
  //       headers
  //     );

  //     setState({
  //       loading: false,
  //       QRCodedata: fetchQRData.data,
  //     });
  //     localStorage.setItem("qrToken", fetchQRData.data.qr_token);

  //     if (fetchQRData.status) {
  //       setIsExpired(false);
  //       setTimeLeft(600); // Reset timer to 10 minutes
  //       if (intervalId) {
  //         clearInterval(intervalId); // Clear the existing interval
  //       }

  //       const id = setInterval(() => {
  //         <ValidateQR navigate={navigateToScreen} />;
  //       }, 1000);
  //       setIntervalId(id);
  //     }
  //   } catch (error) {
  //     // console.error("Error fetching data:", error);
  //     setState({
  //       loading: false,
  //       QRCodedata: null,
  //     });
  //   }
  // };

  const handleEnterKey = (event) => {
    console.log("event...", event);
    console.log("first", event.keyCode);
    if (event.keyCode === 39) {
      handleRight();
      // setLoginData(false); // Update loginData to false
      // setIsFocus(false); // Optionally update isFocus as well
    }
    if (event.keyCode === 13) {
      console.log("first", event.keyCode);
      handleGetNewCode();
      handleRight();
    }
  };

  useEffect(() => {
    console.log("first", loginData);
    if (loginData) {
      window.addEventListener("keydown", handleEnterKey);
    }
    return () => {
      window.removeEventListener("keydown", handleEnterKey);
    };
  }, [loginData]);

  // useEffect(() => {
  //   // Update isFocus based on loginData
  //   setIsFocus(loginData);
  //   console.log(isFocus)
  // }, [loginData]);

  // console.log("isExpired.....", isExpired);

  const loadData = async () => {
    let headers = {
      Version: localStorage.getItem("firmwareVersion"),
      // devicetype: "11",
      Deviceid: localStorage.getItem("sdkVersion"),
      Devicetoken: localStorage.getItem("idValue"),
      Devicemodel: localStorage.getItem("modelName"),
      "Content-Type": "application/json",
    };

    try {
      // const fetchQRData = await fetchContent(
      //   "/V1/generateQrToken",
      //   "GET",
      //   headers
      // );

      const fetchQRData = await generateQrToken();

      setState({
        loading: false,
        QRCodedata: fetchQRData.data,
      });
      localStorage.setItem("qrToken", fetchQRData.data.qr_token);
      if (
        fetchQRData.data.qr_image !== null &&
        fetchQRData.data.qr_image !== ""
      ) {
        if (fetchQRData.status) {
          setIsExpired(false);
          setTimeLeft(600); // Reset timer to 10 minutes
          if (intervalId) {
            clearInterval(intervalId); // Clear the existing interval
          }
          window.clearTime = setInterval(() => {
            validateQR(); // Call the validateQR function
          }, 10000); // 10 seconds
          setIntervalId(window.clearTime);
        }
      } else {
        setIsExpired(true);
        setState({
          loading: false,
          QRCodedata: null,
        });
        if (intervalId) {
          clearInterval(intervalId); // Clear the existing interval
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setIsExpired(true);
      setState({
        loading: false,
        QRCodedata: null,
      });
      if (intervalId) {
        clearInterval(intervalId); // Clear the existing interval
      }
    }
  };

  useEffect(() => {
    console.log("intervalId.....", intervalId);
    if (intervalId) {
      clearInterval(intervalId);
    }
    // Start the timer when the component loads
    const startCountdown = () => {
      const countdown = setInterval(() => {
        setTimeLeft((prevTime) => {
          if (prevTime <= 1) {
            setIsExpired(true);
            clearInterval(countdown);
            setIsExpired(true);
            // loadData();
            // startCountdown();
            return 0; // Set timer to 0 when expired
          }
          return prevTime - 1;
        });
      }, 1000); // Decrease time every second

      setIntervalId(countdown); // Store the interval ID for cleanup
    };

    loadData();
    startCountdown();

    // Cleanup on unmount
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, []); // Empty dependency array to run only once

  const validateQR = async () => {
    console.log("Validating QR token...");
    try {
      const myHeaders = {
        Version: localStorage.getItem("firmwareVersion"),
        Deviceid: localStorage.getItem("sdkVersion"),
        Devicetoken: localStorage.getItem("idValue"),
        Devicemodel: localStorage.getItem("modelName"),
        "Content-Type": "application/json",
      };

      const raw = {
        qr_token: localStorage.getItem("qrToken"),
      };

      console.log("raw...testing", raw, myHeaders);

      // const requestOptions = {
      //   method: "POST",
      //   headers: myHeaders,
      //   body: JSON.stringify(raw),
      // };

      // const [response] = await Promise.all([
      //   fetchContent1("/V1/validateQrToken", "POST", myHeaders, raw),
      // ]);

      const response  = await validateQrToken(JSON.stringify(raw))

      console.log("response...test", response);

      if (response.status === true) {
        if (!qrEventTriggered) {
          sendTestMatomoEvent({
            eventCategory: "ActivateTV",
            eventAction: "QrScanned",
            eventName: "",
          });
          qrEventTriggered = true; // mark as already sent
        }
        if (response.data.jwt === "") {
          console.log("response 310", response.data.tokens);
          localStorage.setItem("JWTToken", response.data.tokens.access);
          localStorage.setItem("refresh", response.data.tokens.refresh);
        } else {
          localStorage.setItem("JWTToken", response.data.jwt);
        }

        localStorage.setItem(
          "user_details",
          JSON.stringify(response.data.user_details)
        );
        // console.log("response login devices....",response, response.data.user_details.is_device_limit_exceeded);
        if (response.data.user_details.is_device_limit_exceeded) {
          // console.log("Device limit exceed....", response);
          localStorage.setItem("user_device_info_id", JSON.stringify(response));
          navigate("ManageDevices", {});
        } else {
          // console.log("Device not exceed.....", response);
          console.log(response.data.user_details.new_user, "login result");
          if (response.data.user_details.new_user === 1) {
            // console.log(selectedElementIndex, profiles[selectedElementIndex]);
            localStorage.setItem(
              "myProfile",
              JSON.stringify(response?.data?.user_details?.user_profiles[0])
            );
            localStorage.setItem(
              "profileId",
              response?.data?.user_details?.user_profiles[0].profileId
            );
            localStorage.setItem(
              "userId",
              response?.data?.user_details?.user_profiles[0].userId
            );
            localStorage.setItem(
              "proImg",
              response?.data?.user_details?.user_profiles[0].profile
            );
            navigate("HomePage", {});
          } else {
            navigate("WhoWatching", {});
          }
        }
        // localStorage.setItem("JWTToken", response?.data?.jwt);
        // localStorage.setItem("mobileNo", response?.data?.user_details?.mobile);
        // localStorage.setItem(
        //   "user_details",
        //   JSON.stringify(response?.data?.user_details)
        // );
        // console.log("QR token is valid. Navigating to next screen...");
        // setTimeout(() => {
        //   navigate("WhoWatching", {});
        // }, 1000);
        setIsLogedIn(true);
        clearInterval(window.clearTime);
        // if (intervalId) {
        //   setIntervalId(null); // Reset interval ID to null
        // }
        // navigateToScreen(); // Navigate to the next screen
      } else {
        console.log("QR token is invalid or expired.");
      }
    } catch (error) {
      console.error("Error validating QR token:", error);
    }
  };

  // Restart the timer when loadData is called again
  const handleGetNewCode = () => {
    if (intervalId) {
      clearInterval(intervalId); // Clear the existing timer
    }
    setIsExpired(false); // Reset expiration state
    loadData(); // Fetch new QR code data
    setTimeLeft(600); // Reset to 10 minutes
    // Start a new countdown
    const countdown = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(countdown);
          setIsExpired(true);
          return 0; // Set timer to 0 when expired
        }
        return prevTime - 1;
      });
    }, 1000);

    setIntervalId(countdown); // Store the new interval ID for future cleanup
  };

  // if (state.loading) {
  //   return <div>Loading...</div>;
  // }

  //Loading in middle 
  if (state.loading) {
    return <div
    style={{alignItems:"center",justifyContent:"center",display:"flex",position:"relative",top:"50%"}}>
           <LoaderScreen />
    </div>;
  }



  const qrimg = {
    width: "35vh",
  };

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(2, "0")}:${remainingSeconds
      .toString()
      .padStart(2, "0")}`;
  };

  return (
    // <div style={{ textAlign: "center", marginTop: "50px", padding: "20px",
     <div style={{ textAlign: "center", marginTop: "4%",boxSizing: "border-box",position: "relative",top: "7%" }}>
      <h1
        style={{
          fontFamily: "Anek Latin",
          fontWeight: "700",
          fontSize: "38px",
        }}
      >
        <Translate langKey={"title_activity_scan_qr_code"} />
      </h1>
      <h4
        style={{
          fontFamily: "Anek Latin",
          fontWeight: "400",
          fontSize: "30px",
          position: "relative",
          bottom: "1rem",
        }}
      >
        <Translate langKey={'Scan_using_app_or_mobile_camera1'}/>
        {/* Scan using app or mobile camera */}
      </h4>
       <div style={{ marginTop: "20px" }}>    
  {state.QRCodedata && !isExpired ? (
    <div
      style={{
        display: "inline-block",
        padding: "40px",
        backgroundColor: "#0a0a3c ",
        borderRadius: "16px",
      }}
    >
      <img style={qrimg} src={state.QRCodedata.qr_image} alt="QR Code" />
    </div>
  ) : (
    <img src={GetNewCode} alt="New Code" />
  )}
</div>
      <div style={{ textAlign: "center", marginTop: "50px", padding: "20px" }}>
        {!isExpired ? (
          <p
            style={{
              fontSize: "2.4rem",
              position: "relative",
              bottom: "4.5rem",
              fontFamily: "Anek Latin",
              fontWeight: "700",
            }}
          >
            {/* Time left: {formatTime(timeLeft)} */}
            {formatTime(timeLeft)}&nbsp; <Translate langKey={"left"} />
          </p>
        ) : (
          <CustomButton
            fontSize={resolution === "FHD" ? "24px" : "24px"}
            defaultSelected={loginData}
            // width={resolution === "FHD" ? "20vw" : "20vw"}
            height={resolution === "FHD" ? "7vh" : "7vh"}
            top={resolution === "FHD" ? "-3vh" : "-3vh"}
            // left={resolution === "FHD" ? "7vw" : "-10vw"}
            // right={resolution === "FHD" ? "0vw" : "0vw"}
            onClick={handleGetNewCode}
            // border={isMobile ? "2px solid #FF671F" : "2px solid #393939"}
            style={{
              width: resolution === "FHD" ? "20vw" : "20vw",
              // border: isMobileSelected
              //   ? "2px solid red!important"
              //   : "2px solid red", // Apply red border if selected, transparent otherwise
            }}
          >
            <Translate langKey={"get_a_new_code"} />
          </CustomButton>
          // <button
          //   style={{
          //     background: "rgba(35, 35, 37, 1)",
          //     color: "rgba(255, 255, 255, 1)",
          //     width: "36vh",
          //     height: "7vh",
          //     position: "relative",
          //     bottom: "4vh",
          //     fontFamily: "Anek Latin",
          //     fontWeight: 400,
          //     fontSize: "20px",
          //   }}
          //   onKeyDown={handleGetNewCode} // Regenerate the QR code and restart the timer
          // >
          //   <Translate langKey={'get_a_new_code'}/>
          // </button>
        )}
      </div>
    </div>
  );
};

export default QRCodeGenerator;